import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

export default function SIPInvest() {
  const [sipAmount, setSipAmount] = useState(3000);
  const [sipDate, setSipDate] = useState(5);
  const [frequency, setFrequency] = useState("Monthly");
  const [mandate, setMandate] = useState("mandate1");

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9" }}>
<style>{`
.btn-outline-custom {
    border: 1px solid rgba(15, 118, 110, 0.12);
    color: #0f766e;
    background: transparent;
}
    .link-btn {
  margin-top: 10px;
  background: none;
  border: none;
  color: #0f766e;
  font-weight: 500;
  cursor: pointer;
}
  button.link-btn:hover {
   color: #2563eb;                          
}
`}</style>

          <div className="card shadow-sm p-4 mb-4">
            <h3 className="text-primary mb-2">Start SIP</h3>

            {/* Breadcrumb with custom link color */}
            <nav
              aria-label="breadcrumb"
              style={{ "--bs-breadcrumb-divider": "none" }}
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/overview">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/clientmutualfunds">Mutual Funds</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  SIP Invest
                </li>
              </ol>
            </nav>
</div>
            {/* Fund Summary */}
            <div className="card p-4 mb-4 shadow-sm">
              <h5>Axis Bluechip Fund – Direct Growth</h5>
              <p className="muted">Large Cap • Equity • Moderate Risk</p>
            </div>

            {/* SIP Form */}
            <div className="card p-4 mb-4 shadow-sm">
              <h5 className="section-title">SIP Details</h5>

              <div className="sip-form-grid">
                {/* Amount */}
                <div>
                  <label>SIP Amount (₹)</label>
                  <input
                    type="number"
                    min="500"
                    value={sipAmount}
                    onChange={(e) => setSipAmount(e.target.value)}
                  />
                  <small>Minimum ₹500</small>
                </div>

                {/* SIP Date */}
                <div>
                  <label>SIP Date</label>
                  <select
                    value={sipDate}
                    onChange={(e) => setSipDate(e.target.value)}
                  >
                    {[1, 5, 10, 15, 20, 25].map((d) => (
                      <option key={d} value={d}>
                        {d}th of every month
                      </option>
                    ))}
                  </select>
                </div>

                {/* Frequency */}
                <div>
                  <label>Frequency</label>
                  <select
                    value={frequency}
                    onChange={(e) => setFrequency(e.target.value)}
                  >
                    <option>Monthly</option>
                    <option>Quarterly</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Mandate Section */}
            <div className="card p-4 mb-4 shadow-sm">
              <h5 className="section-title">Select Mandate</h5>
              <div className="mandate-box">
                <label className="mandate-item">
                  <input
                    type="radio"
                    checked={mandate === "mandate1"}
                    onChange={() => setMandate("mandate1")}
                  />
                  <div>
                    <strong>HDFC Bank</strong>
                    <p>Max ₹50,000 • Approved</p>
                  </div>
                </label>

                <label className="mandate-item">
                  <input type="radio" disabled />
                  <div>
                    <strong>ICICI Bank</strong>
                    <p className="danger">Pending approval</p>
                  </div>
                </label>
              </div>

              <button className="link-btn">+ Create New Mandate</button>
            </div>

            {/* Schedule Preview */}
            <div className="card p-4 mb-4 shadow-sm">
              <h5 className="section-title">Schedule Preview</h5>
              <ul className="preview-list">
                <li>First Debit: 5th Oct 2026</li>
                <li>Amount: ₹{sipAmount}</li>
                <li>Frequency: {frequency}</li>
                <li>Mandate: HDFC Bank</li>
              </ul>
            </div>

            {/* Actions */}
            <div className="sip-actions">
              <button className="btn  btn-outline-custom">Cancel</button>
              <button className="btn btn-primary">Confirm SIP</button>
            </div>

            {/* Info */}
            <p className="sip-info">
              ℹ  SIP will be created only if mandate is approved and sufficient
              limit is available.
            </p>
          </div>
    </>
  );
}
